import { Checkbox } from '@mui/material';
import { useCallback } from 'react';
import './styles.scss';

export interface Item {
  value: string;
  label: string;
  isDefault?: boolean;
  id?: string;
  // When true the row is shown but greyed and non-selectable (e.g. a metric
  // whose backend support is not yet live).
  disabled?: boolean;
}

export interface MultiSelectListFiltersProps {
  items: Item[];
  selectedItems: Item[];
  setSelectedItems: (items: Item[]) => void;
  classNames?: string;
  isTruncateLabel?: boolean;
}

export const MultiSelectListFilters: React.FC<MultiSelectListFiltersProps> = ({
  items,
  selectedItems,
  setSelectedItems,
  classNames,
  isTruncateLabel = true,
}) => {
  const handleCheckboxChange = (item: Item) => {
    const isChecked = selectedItems.some((selectedItem) => selectedItem.value === item.value);

    if (isChecked) {
      setSelectedItems(selectedItems.filter((selectedItem) => selectedItem.value !== item.value));
    } else {
      setSelectedItems([...selectedItems, item]);
    }
  };

  const isChecked = (item: Item) =>
    selectedItems.some((selectedItem) => selectedItem.value === item.value);

  const truncateLabel = useCallback((label: string, maxLength = 20): string => {
    if (label.length >= maxLength) {
      return `${label.substring(0, maxLength - 3)}...`;
    }
    return label;
  }, []);

  return (
    <div className={`multi-select-list-filters ${classNames}`}>
      {items.map((item) => (
        <label
          key={item.value}
          className={`checkbox-filter-item${item.disabled ? ' checkbox-filter-item--disabled' : ''}`}
        >
          <Checkbox
            checked={isChecked(item)}
            disabled={item.disabled}
            onChange={() => {
              if (!item.disabled) handleCheckboxChange(item);
            }}
          />
          <span>{isTruncateLabel ? truncateLabel(item.label) : item.label}</span>
        </label>
      ))}
    </div>
  );
};
